import React, { Component, PropTypes } from 'react';
import moment from 'moment';
import { Link } from 'react-router';
import Tooltip from 'react-tooltip';
import Thumbnail from 'common/components/thumbnail';
import trailingSlashIt from 'trailing-slash-it';
import { getTimeLeftLabel, isMobile } from 'common/utils';
import { ADMIN_ROOT } from 'common/variables';

/**
 * Wrapup sidebar.
 *
 * @author Nathan Ozelim <nathan@startupfoundry.com>
 */

const IMAGE_GUIDE_URL = '/help/guides/design-projects-wrapup/';
const NAME_GUIDE_URL = '/help/guides/naming-projects-wrapup/';

export default class WrapupSidebar extends Component {
  renderThumbnail() {
    const { wrapup: {entry} } = this.props
    /* image project */
    if (entry['entry_type'] == 'image') {
      return <Thumbnail image={entry.thumbnail} className="thumbnail flex tile" />;
    }
    /* name project */
    if (entry['entry_type'] == 'name') {
      return <h1>{entry.name}</h1>;
    }
  }

  render() {
    const { wrapup, feedbackSubmitted, isAdmin } = this.props;
    const entryUrl = trailingSlashIt(wrapup.project_url) + `entry/${wrapup.entry.id}/`;
    const guideUrl = wrapup.entry.entry_type === 'image'? IMAGE_GUIDE_URL : NAME_GUIDE_URL;
    const creativeUrl = (
      isAdmin? `${ADMIN_ROOT}/creative/${wrapup.creative.id}/` : `/users/${wrapup.creative.username}/`
    );

    return (
      <div className="sidebar">
        <h3 className="show-for-small-only">Wrap-up information</h3>
        <div className="row columns sidebar-section">
          <div className="wrapup-thumbnail">
            { this.renderThumbnail() }
          </div>
          <div className="entry-info">
            <Link target="_blank" to={creativeUrl}>{ wrapup.creative.username }</Link>
            <Link target="_blank" to={entryUrl}>Entry #{ wrapup.entry.entry_number }</Link>
          </div>
        </div>
        { !feedbackSubmitted &&
        <div className="row columns sidebar-section">
          Need help? <Link target="_blank" to={guideUrl}>Wrap-up guide</Link>
        </div> }
        { !feedbackSubmitted &&
        <div className="row columns sidebar-section" data-tip={true} data-for="time_left_tooltip"
            data-event={isMobile()? "click" : undefined}>
          <label>Time left to finish wrap-up</label>
          <h1>{ getTimeLeftLabel(wrapup.deadline, {forceMax: false}) }</h1>

          <Tooltip class="tooltip" effect="solid" place="left" id="time_left_tooltip">
            <p>Awarded: { moment(wrapup.award.created_at).format('MMMM D, YYYY hh:mm a') }.</p>
            <p>
              Please complete your wrap-up
              by { moment(wrapup.deadline).format('MMMM D, YYYY hh:mm a') }.
            </p>
          </Tooltip>
        </div> }
      </div>
    );
  }
}

WrapupSidebar.propTypes = {
  wrapup: PropTypes.object.isRequired,
  feedbackSubmitted: PropTypes.bool.isRequired,
  isAdmin: PropTypes.bool,
};



// WEBPACK FOOTER //
// ./project/components/wrapup/sidebar.jsx